<div class="modal-body">
  <div class="row">
    <div class="mb-3 text-secondary col-12">
      <small class="form-text">Les champs marqués d'un <em class="text-danger">*</em> sont obligatoires. </small>
    </div>
    <div class="col-12">
      <h5 class="text-primary">Adresse du siège</h5>
    </div>
    <app-structure-address-form [form]="mainAddressForm" [submitted]="submitted"></app-structure-address-form>
  </div>
  <div class="row">
    <div class="row">
      <div class="col-11">
        <h5 class="text-primary">Autres adresses</h5>
      </div>
      <div class="col-1">
        <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" (click)="resetSecondaryForm()">
          <fa-icon icon="plus"></fa-icon>
        </button>
      </div>
    </div>

    <app-structure-address-form [form]="secondaryAddressesForm" [submitted]="secondarySubmitted"></app-structure-address-form>
    <div class="col-3 d-md-none d-lg-block col-lg-9 mb-3"></div>
    <div class="d-grid col-3 col-md-6 col-lg-3 mb-3">
      <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="updateSecondaryAddress()">
        <fa-icon icon="check"></fa-icon>
        <span class="ms-3 d-none d-md-block">Valider l'adresse</span>
      </button>
    </div>
    <div class="row mt-2">
      <div class="col">
        <table class="table table-sm table-striped table-hover" aria-describedby="structuresAddress">
          <thead class="text-secondary bg-light">
            <tr>
              <th></th>
              <th scope="col" class="text-center">Nom</th>
              <th scope="col" class="text-center">Adresse</th>
              <th scope="col" class="text-center">Téléphone</th>
              <th scope="col" class="text-center">Active</th>
              <th scope="col" class="text-center">Site accueillant le public</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let address of secondaryAddresses; let index = index">
              <td></td>
              <td (click)="loadAddressByIndex(index)" class="text-center">{{ address.name }}</td>
              <td (click)="loadAddressByIndex(index)">
                {{ address.address }} - {{ address.additionalAddress }}, {{ address.postalCode }}
                {{ address.city }}
              </td>
              <td (click)="loadAddressByIndex(index)">{{ address.phone }}</td>
              <td (click)="loadAddressByIndex(index)">
                {{ address.active ? 'Active' : 'Inactive' }}
              </td>
              <td (click)="loadAddressByIndex(index)">
                {{ address.publicReception ? 'Oui' : 'Non' }}
              </td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="secondaryAddresses.length === 0">Aucune autres adresses.</p>
      </div>
    </div>
  </div>
</div>
